var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInvestmentLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.8843C0 25.2331 0.0572254 25.5812 0.197672 25.901C1.20819 28.2021 3.12546 29.8827 5.4556 30.9516C9.7011 29.5393 11.2381 26.0939 11.4136 24.5338V17.317C11.4136 14.1137 10.8124 10.657 8.11858 8.92373C5.38992 7.16803 2.0073 6.6218 0 6.6218V24.8843Z",
    fill: "#BA0C0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 0.357971C17.8657 0.641632 12.9106 3.57563 12.079 7.75151C12.0536 7.87931 12.0437 8.00989 12.0437 8.14014V14.0313V24.7934C11.8666 26.3674 10.4673 29.8725 6.28711 31.3005C12.7538 33.7756 21.7572 31.8898 23.8723 25.811C23.9635 25.5487 23.9997 25.2701 23.9997 24.9927V0.357971Z",
    fill: "url(#paint0_linear_1527_1914)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1527_1914",
    x1: 24.0255,
    y1: 0.357971,
    x2: 7.34416,
    y2: 32.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197115,
    stopColor: "#FE9F5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.600962,
    stopColor: "#D50E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985577,
    stopColor: "#6F0706"
  })))));
}

export default __webpack_public_path__ + "media/8364d609.svg";
export { SvgInvestmentLogo as ReactComponent };